module.exports = __webpack_public_path__ + "img/confirmico.43c87c13.gif";